import { observer } from 'mobx-react-lite';
import React from 'react';

import PropertyDropdown from '../common/PropertyDropdown';

import type { ElementState } from '../../renderer/ElementState';
import type { EditorStoreLike } from '@src/utility/compositionSettings';

interface PropertySelectProps {
  activeElement: ElementState;
  propertyName: string;
  defaultValue: any;
  options: Array<{ caption: string; value: any }>;
  editorStore: EditorStoreLike;
}

export const PropertySelect: React.FC<PropertySelectProps> = observer(props => {
  const editorStore = props.editorStore;

  // Update property using headless editor
  const updateProperty = async (propertyName: string, value: any) => {
    if (!props.activeElement?.source?.id) return;
    editorStore.editor.commandUpdateElement(props.activeElement.source.id, {
      [propertyName]: value,
    });
  };

  return (
    <PropertyDropdown
      value={
        props.activeElement.source[props.propertyName] ?? props.defaultValue
      }
      onChange={async value => {
        await updateProperty(props.propertyName, value);
      }}
      defaultValue={
        props.activeElement.source[props.propertyName] ?? props.defaultValue
      }
      values={props.options.map(({ value, caption }) => ({ value, caption }))}
    />
  );
});
